import React from "react";
import PropTypes from "prop-types";
import Youtube from "core-web/components/Youtube";

const YouTubePlayerBlock = ({ content }) => {
    if (!content) {
        return null;
    }

    const { embed_url: embedUrl } = content?.data || {};

    return embedUrl && <Youtube embedUrl={embedUrl} loading="lazy" showVideoByDefault />;
};

YouTubePlayerBlock.propTypes = {
    content: PropTypes.object,
};

YouTubePlayerBlock.defaultProps = {
    content: {},
};

export default YouTubePlayerBlock;
